module.exports = __webpack_public_path__ + "img/Considerate Career.b5f1a848.svg";